// src/config/constants.ts

/**
 * Application-wide constants
 */

/**
 * Public-facing support email. Used in error messages, blocking screens,
 * and any UI that asks the user to contact us. Single source of truth so
 * a future address change touches one place.
 */
export const SUPPORT_EMAIL = "support@contract.space";

/**
 * Message sent when user clicks the fact-check button to validate AI responses.
 * This instructs the LLM to double-check facts, calculations, and assumptions.
 *
 * NOTE: This entire suffix is sent as the user message (not appended to AI's response).
 * When displayed in chat history, it's replaced with "Double checking the fact in your response..."
 * for better UX, while the LLM receives the full instruction.
 */
export const DOUBLE_CHECK_SUFFIX =
  "Please double-check facts, calculations, and assumptions; provide citations when available and indicate confidence levels in your response.";
